export default __webpack_public_path__ + "static/media/done-checkmarkFasting.568cf788.svg";